export { default } from './SingleSignatureBlock';
